// Browser-local persistence for real-model runs, so a reload does not throw away a run that
// cost model spend. Simulated runs are cheap and the seed history regenerates, so only real
// runs are kept. A stopgap until the backend stores runs (plan §8 dep #4): it lives in this
// browser only and is never sent anywhere. Stored per workspace, like the datasets the runs
// were made from; without a workspace nothing is read or saved.

import { logError } from 'lib/logging'
import type { Run } from './types'

const STORAGE_KEY_PREFIX = `ops-evals:runs:v1:`

export function loadStoredRuns(workspaceId: string | undefined): Run[] {
  try {
    const raw = workspaceId && window.localStorage.getItem(`${STORAGE_KEY_PREFIX}${workspaceId}`)
    return raw ? (JSON.parse(raw) as Run[]) : []
  } catch (error) {
    logError(`Could not read stored eval runs`, error)
    return []
  }
}

/** Keeps a finished real-model run; simulated runs are not stored. */
export function storeRun(workspaceId: string | undefined, run: Run): void {
  if (!workspaceId || run.execution === `simulated`) return
  try {
    window.localStorage.setItem(
      `${STORAGE_KEY_PREFIX}${workspaceId}`,
      JSON.stringify([run, ...loadStoredRuns(workspaceId)]),
    )
  } catch (error) {
    logError(`Could not store eval run`, error)
  }
}
